import { Data } from "popper.js"
import { Localizacao } from "../localizacao/localizacao.model"
import { data } from "jquery"
import { v4 as uuidv4 } from 'uuid';


export class Mdc {
    //Generic CLS
    [key: string]: any
    // ID    
    mdcId: number = 0
    // IDENTIFICAÇÃO 
    i_1: number | null = null
    i_2: number | null = null
    i_3: number | null = null
    // SECÇÃO I
    mdc_1: string | null = null
    mdc_2: number | null = null
    mdc_3: number | null = null
    mdc_4: Date | null = null
    mdc_5: number | null = null
    mdc_6: number | null = null
    mdc_6_1: number | null = null
    mdc_7: number | null = null
    mdc_8: number | null = null
    mdc_9: number | null = null
    mdc_10: number | null = null
    mdc_10_mes_ano: number | null = null
    mdc_11: number[] = [];
    mdc_11_outro: string | null = null
    mdc_12_1: number | null = null
    mdc_12_2: number | null = null
    mdc_12_3: number | null = null
    mdc_13: number | null = null
    mdc_14: string | null = null
    mdc_15: number | null = null
    mdc_16: number | null = null
    // SECÇÃO II
    mdc_17: number | null = null
    mdc_18: number | null = null
    mdc_19: string | null = null   
    mdc_20: number | null = null
    // SECÇÃO III
    mdc_21: number | null = null
    mdc_21_outro: string | null = null
    mdc_22: number | null = null
    mdc_22_outro: string | null = null
    mdc_23: string | null = null
    mdc_24: number | null = null
    mdc_24_outro: string | null = null
    mdc_25: number | null = null
    mdc_25_outro: string | null = null
    mdc_26: number | null = null
    mdc_26_1: string | null = null
    mdc_27_1: number | null = null
    mdc_27_2: number | null = null
    mdc_27_3: number | null = null
    // SECÇÃO IV
    mdc_28: number | null = null
    mdc_29: number | null = null
    mdc_29_outro: string | null = null
    mdc_30: number[] = [];
    mdc_30_outro: string | null = null
    mdc_31: number | null = null
    // SECÇÃO V
    mdc_32: number | null = null  
    mdc_33: number[] = [];
    mdc_34: number[] = [];
    mdc_34_outro: string | null = null
    mdc_35_1: number | null = null
    mdc_35_2: number | null = null
    mdc_35_3: number | null = null
    mdc_35_4: number | null = null
    mdc_35_5: number | null = null
    mdc_35_6: number | null = null
    mdc_36: number | null = null
    mdc_37: number | null = null
    mdc_38: number[] = [];
    mdc_38_outro: string | null = null
    mdc_39: number | null = null
    mdc_39_outro: string | null = null
    // SECÇÃO VI
    mdc_40: number | null = null    
    // SECÇÃO VII
    mdc_41: number | null = null
    mdc_41_1_1: string | null = null
    mdc_41_1_2: string | null = null
    mdc_41_1_3: string | null = null
    localizacao: Localizacao = new Localizacao();
    submissionHash: string | null = null;

    constructor() {
        this.submissionHash = uuidv4();
    }
}

export class MdcCode {
    mdc: Mdc = new Mdc();
    phonenumberoremail: string = "";
    code: any  | null = null;
    lang: string = "";
}

export class MdcOffline {
    id: number = 0;
    mdc: Mdc = new Mdc();
    data: Date = new Date();
}

export class MdcOfflineSync {
  id!: number;
  email!: string;
  created_at!: Date;
  sync_status!: number;
  mdc!: Mdc;
}